import { TwitterShareButton } from 'react-share';
import { FC } from 'react';
import { Box, Center, Text, VStack } from '@chakra-ui/react';
import { Twitter } from '../../assets';
import { getDataTracking } from '../../utils';
import { TrackingLabelProps } from '../../types/global';

export interface TwitterShareProps extends TrackingLabelProps {
  url: string;
  hasSupportText?: boolean;
}

export const TwitterShare: FC<TwitterShareProps> = ({
  url,
  hasSupportText = true,
  trackingLabel,
}) => (
  <TwitterShareButton url={url} {...getDataTracking(`${trackingLabel}Twitter`)}>
    <Center w="140px" h="126px">
      <VStack>
        <Twitter boxSize="64px" />
        {hasSupportText && (
          <Box mt={2}>
            <Text fontSize="md">X</Text>
          </Box>
        )}
      </VStack>
    </Center>
  </TwitterShareButton>
);
